export default class StatusConstant{
  public static PAUSED   = 'PAUSED'
  public static ENABLED  = 'ENABLED'
}